import { create } from 'zustand'

interface AidaChatCommandsState {
  activeConversationId: string | null
  activeConversationTitle: string
  canStartNewChat: boolean
  pendingDeleteId: string | null
  onNewChat: () => void
  onDeleted: (conversationId: string) => void
  requestDelete: (conversationId: string) => void
  cancelDelete: () => void
}

export const useAidaChatCommands = create<AidaChatCommandsState>(set => ({
  activeConversationId: null,
  activeConversationTitle: 'New chat',
  canStartNewChat: false,
  pendingDeleteId: null,
  onNewChat: () => {},
  onDeleted: () => {},
  requestDelete: conversationId => {
    set({ pendingDeleteId: conversationId })
  },
  cancelDelete: () => {
    set({ pendingDeleteId: null })
  },
}))
